export type { IOriginCountry } from "./interfaces";
export { useGetOriginCountries } from "./useGetOriginCountries";
